import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import MonthlyVatReportExpenseSCCD from './vat-report-expense-sccd';

export default class MonthlyVatReportSCCD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: !props.monthlyVatReportData,
      momentFormatString: 'ddd Do MMM YYYY',
      momentFormatStringCSV: 'ddd Do MMM YYYY - HHmmss',
      monthlyVatReportData: props.monthlyVatReportData || [],
      url: props.url ||
        '/api/v1/portal/finance/vat-report-sccd',
      currentMonthYear: props.year || moment().year(),
      currentMonthNumber: props.month || moment().month() + 1,
    };
    this.setCurrentMonth = this.setCurrentMonth.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
  }
  getMonthlyVatReportData(monthNumber, monthYear) {
    return fetch(
      this.state.url +
      '/' + monthNumber + '/' + monthYear,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          this.setState({
            monthlyVatReportData: response,
            isLoading: false
          })
        });
      });
  }
  componentDidMount() {
    if (this.state.isLoading) {
      this.getMonthlyVatReportData(
        this.state.currentMonthNumber,
        this.state.currentMonthYear
      );
    }
  }
  setCurrentMonth(e) {
    this.setState({
      currentMonthNumber: e.target.value,
      isLoading: true
    });
    let monthNumber = e.target.value;
    this.getMonthlyVatReportData(monthNumber, this.state.currentMonthYear);
  }
  buildYearOptions() {
      var arr = [];
      for (let i = 1; i <= 1; i++) {
          let nyear = moment().add(i, 'years').format('YYYY');
          arr.push(<option key={i+nyear} value={nyear}>{nyear}</option>)
      }
      return arr; 
  }
  handleYearChange(e){
      this.setState({currentMonthYear:e.target.value});
  }
  buildPrevYearOptions() {
      var arr = [];
      for (let i = 1; i >= 1; i--) {
          let pyear = moment().subtract(i, 'years').format('YYYY');
          arr.push(<option key={i+pyear} value={pyear}>{pyear}</option>)
      }
      return arr; 
  }
  buildMonthOptions() {
      var arr = [];
      for (let i = 1; i <= 12; i++) {
      arr.push(<option key={i} value={i}>{moment(i, 'MM').format('MMM')}</option>)
      }
      return arr; 
  }
  download(filename, text) {
    text = "Job ID,Vehicle Registration,Net,VAT,Gross,Type\n"+text;
    let element = document.createElement(
      'a'
    );
    element.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
    );
    element.setAttribute(
      'download',
      filename
    );
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  render() {
    let currentMonthNumber = this.state.currentMonthNumber;
    let currentYear = this.state.currentMonthYear;
    let currentMonthName = moment(currentMonthNumber, 'MM').
      format('MMMM');
    let previousYear = currentYear - 1;
    let nextYear = currentYear + 1;
    let previousMonthYear = previousYear;
    let previousMonthNumber = currentMonthNumber - 1;
    let nextMonthNumber = currentMonthNumber + 1;
    let nextMonthYear = currentYear;
    if (currentMonthNumber > 1) {
      previousMonthNumber = currentMonthNumber - 1;
      previousMonthYear = currentYear;
    }
    else {
      previousMonthNumber = 12;
      previousMonthYear = previousYear;
    }
    if (currentMonthNumber < 12) {
      nextMonthNumber = currentMonthNumber + 1;
      nextMonthYear = currentYear;
    }
    else {
      nextMonthNumber = 1;
      nextMonthYear = nextYear;
    }

    let previousMonthName = moment(previousMonthNumber, 'MM').
      format('MMMM');
    let nextMonthName = moment(nextMonthNumber, 'MM').
      format('MMMM');
    let currentJob, currentExpense, currentExpenseToInclude;
    let FuelExpenses = [],
      VehicleExpenses = [],
      TollRoadExpenses = [],
      WaitingTimeExpenses = [],
      StorageExpenses = [],
      BreakdownExpenses = [],
      TravelExpenses = [],
      CarWashExpenses = [],
      PartsExpenses = [],
      TransportsExpenses = [],
      HotelExpenses = [],
      // All Expenses Extraction started
      TruckTravelExpenses = [],
      TruckFuelExpenses = [],
      ElectricChargeCostExpenses = [],
      ElectricChargingTimeExpenses = [],
      ParkingExpenses = [],
      WaterExpenses = [],
      CoolantExpenses = [],
      FoodExpenses = [],
      AirExpenses = [],
      // All Expenses Extraction end
      AllOtherExpenses = [];

    let FuelExpensesVatTotal = 0;
    let FuelExpensesNetAmountTotal = 0;
    let FuelExpensesGrossTotal = 0;
    let FuelExpensesTotal = 0;

    let VehicleExpensesVatTotal = 0;
    let VehicleExpensesNetAmountTotal = 0;
    let VehicleExpensesGrossTotal = 0;
    let VehicleExpensesTotal = 0;

    let TollRoadExpensesVatTotal = 0;
    let TollRoadExpensesNetAmountTotal = 0;
    let TollRoadExpensesGrossTotal = 0;
    let TollRoadExpensesTotal = 0;

    let WaitingTimeExpensesVatTotal = 0;
    let WaitingTimeExpensesNetAmountTotal = 0;
    let WaitingTimeExpensesGrossTotal = 0;
    let WaitingTimeExpensesTotal = 0;

    let StorageExpensesVatTotal = 0;
    let StorageExpensesNetAmountTotal = 0;
    let StorageExpensesGrossTotal = 0;
    let StorageExpensesTotal = 0;

    let BreakdownExpensesVatTotal = 0;
    let BreakdownExpensesNetAmountTotal = 0;
    let BreakdownExpensesGrossTotal = 0;
    let BreakdownExpensesTotal = 0;

    let TravelExpensesVatTotal = 0;
    let TravelExpensesNetAmountTotal = 0;
    let TravelExpensesGrossTotal = 0;
    let TravelExpensesTotal = 0;

    let CarWashExpensesVatTotal = 0;
    let CarWashExpensesNetAmountTotal = 0;
    let CarWashExpensesGrossTotal = 0;
    let CarWashExpensesTotal = 0;

    let PartsExpensesVatTotal = 0;
    let PartsExpensesNetAmountTotal = 0;
    let PartsExpensesGrossTotal = 0;
    let PartsExpensesTotal = 0;

    let TransportsExpensesVatTotal = 0;
    let TransportsExpensesNetAmountTotal = 0;
    let TransportsExpensesGrossTotal = 0;
    let TransportsExpensesTotal = 0;

    let HotelExpensesVatTotal = 0;
    let HotelExpensesNetAmountTotal = 0;
    let HotelExpensesGrossTotal = 0;
    let HotelExpensesTotal = 0;

    // All Expenses Extraction started
    let TruckTravelExpensesVatTotal = 0;
    let TruckTravelExpensesNetAmountTotal = 0;
    let TruckTravelExpensesGrossTotal = 0;
    let TruckTravelExpensesTotal = 0;

    let TruckFuelExpensesVatTotal = 0;
    let TruckFuelExpensesNetAmountTotal = 0;
    let TruckFuelExpensesGrossTotal = 0;
    let TruckFuelExpensesTotal = 0;

    let ElectricChargeCostExpensesVatTotal = 0;
    let ElectricChargeCostExpensesNetAmountTotal = 0;
    let ElectricChargeCostExpensesGrossTotal = 0;
    let ElectricChargeCostExpensesTotal = 0;

    let ElectricChargingTimeExpensesVatTotal = 0;
    let ElectricChargingTimeExpensesNetAmountTotal = 0;
    let ElectricChargingTimeExpensesGrossTotal = 0;
    let ElectricChargingTimeExpensesTotal = 0;

    let ParkingExpensesVatTotal = 0;
    let ParkingExpensesNetAmountTotal = 0;
    let ParkingExpensesGrossTotal = 0;
    let ParkingExpensesTotal = 0;

    let WaterExpensesVatTotal = 0;
    let WaterExpensesNetAmountTotal = 0;
    let WaterExpensesGrossTotal = 0;
    let WaterExpensesTotal = 0;

    let CoolantExpensesVatTotal = 0;
    let CoolantExpensesNetAmountTotal = 0;
    let CoolantExpensesGrossTotal = 0;
    let CoolantExpensesTotal = 0;
    
    let FoodExpensesVatTotal = 0;
    let FoodExpensesNetAmountTotal = 0;
    let FoodExpensesGrossTotal = 0;
    let FoodExpensesTotal = 0;
    
    let AirExpensesVatTotal = 0;
    let AirExpensesNetAmountTotal = 0;
    let AirExpensesGrossTotal = 0;
    let AirExpensesTotal = 0;
    // All Expenses Extraction end

    let AllOtherExpensesVatTotal = 0;
    let AllOtherExpensesNetAmountTotal = 0;
    let AllOtherExpensesGrossTotal = 0;
    let AllOtherExpensesTotal = 0;

    let downloadableCsvDataFuel = "";
    let downloadableCsvDataVehicle = "";
    let downloadableCsvDataTollRoad = "";
    let downloadableCsvDataWaitingTime = "";
    let downloadableCsvDataStorage = "";
    let downloadableCsvDataBreakdown = "";
    let downloadableCsvDataTravel = "";
    let downloadableCsvDataCarWash = "";
    let downloadableCsvDataParts = "";
    let downloadableCsvDataTransports = "";
    let downloadableCsvDataHotel = "";

    // All Expenses Extraction started
    let downloadableCsvDataTruckTravel = "";
    let downloadableCsvDataTruckFuel = "";
    let downloadableCsvDataElectricChargeCost = "";
    let downloadableCsvDataElectricChargingTime = "";
    let downloadableCsvDataParking = "";
    let downloadableCsvDataWater = "";
    let downloadableCsvDataCoolant = "";
    let downloadableCsvDataFood = "";
    let downloadableCsvDataAir = "";
    // All Expenses Extraction end  

    let downloadableCsvDataAllOthers = "";
    let downloadableCsvDataAllCodes = "";

    for (let job in this.state.monthlyVatReportData) {
      currentJob = this.state.monthlyVatReportData[job];

      if (currentJob['expenses']) {
        for (let expense in currentJob['expenses']) {
          currentExpense = currentJob['expenses'][expense];
          if (currentExpense['clean']) {
            currentExpenseToInclude = currentExpense['clean'];
            if (currentExpenseToInclude['NOMINAL_CODE'] == '4001') {
              FuelExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              FuelExpensesVatTotal = (FuelExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              FuelExpensesNetAmountTotal = (FuelExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              FuelExpensesGrossTotal = (FuelExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              FuelExpensesTotal = (FuelExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataFuel = downloadableCsvDataFuel +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";

            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4000') {
              VehicleExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              VehicleExpensesVatTotal = (VehicleExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              VehicleExpensesNetAmountTotal = (VehicleExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              VehicleExpensesGrossTotal = (VehicleExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              VehicleExpensesTotal = (VehicleExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataVehicle = downloadableCsvDataVehicle +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4002' || currentExpenseToInclude['NOMINAL_CODE'] == '4012') {
              TollRoadExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              TollRoadExpensesVatTotal = (TollRoadExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TollRoadExpensesNetAmountTotal = (TollRoadExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              TollRoadExpensesGrossTotal = (TollRoadExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TollRoadExpensesTotal = (TollRoadExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataTollRoad = downloadableCsvDataTollRoad +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4003') {
              WaitingTimeExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              WaitingTimeExpensesVatTotal = (WaitingTimeExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              WaitingTimeExpensesNetAmountTotal = (WaitingTimeExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              WaitingTimeExpensesGrossTotal = (WaitingTimeExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              WaitingTimeExpensesTotal = (WaitingTimeExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataWaitingTime = downloadableCsvDataWaitingTime +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4004') {
              StorageExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              StorageExpensesVatTotal = (StorageExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              StorageExpensesNetAmountTotal = (StorageExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              StorageExpensesGrossTotal = (StorageExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              StorageExpensesTotal = (StorageExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataStorage = downloadableCsvDataStorage +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4005') {
              BreakdownExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              BreakdownExpensesVatTotal = (BreakdownExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              BreakdownExpensesNetAmountTotal = (BreakdownExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              BreakdownExpensesGrossTotal = (BreakdownExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              BreakdownExpensesTotal = (BreakdownExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataBreakdown = downloadableCsvDataBreakdown +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4006') {
              TravelExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              TravelExpensesVatTotal = (TravelExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TravelExpensesNetAmountTotal = (TravelExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              TravelExpensesGrossTotal = (TravelExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TravelExpensesTotal = (TravelExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataTravel = downloadableCsvDataTravel +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4007') {
              CarWashExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              CarWashExpensesVatTotal = (CarWashExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              CarWashExpensesNetAmountTotal = (CarWashExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              CarWashExpensesGrossTotal = (CarWashExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              CarWashExpensesTotal = (CarWashExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataCarWash = downloadableCsvDataCarWash +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4008') {
              PartsExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              PartsExpensesVatTotal = (PartsExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              PartsExpensesNetAmountTotal = (PartsExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              PartsExpensesGrossTotal = (PartsExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              PartsExpensesTotal = (PartsExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataParts = downloadableCsvDataParts +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4009') {
              TransportsExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              TransportsExpensesVatTotal = (TransportsExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TransportsExpensesNetAmountTotal = (TransportsExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              TransportsExpensesGrossTotal = (TransportsExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TransportsExpensesTotal = (TransportsExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataTransports = downloadableCsvDataTransports +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '7402' || currentExpenseToInclude['NOMINAL_CODE'] == '4011') {
              HotelExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              HotelExpensesVatTotal = (HotelExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              HotelExpensesNetAmountTotal = (HotelExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              HotelExpensesGrossTotal = (HotelExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              HotelExpensesTotal = (HotelExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataHotel = downloadableCsvDataHotel +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } 
            // All Expenses Extraction started
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4022') {
              TruckTravelExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              TruckTravelExpensesVatTotal = (TruckTravelExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TruckTravelExpensesNetAmountTotal = (TruckTravelExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              TruckTravelExpensesGrossTotal = (TruckTravelExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TruckTravelExpensesTotal = (TruckTravelExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataTruckTravel = downloadableCsvDataTruckTravel +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4021') {
              TruckFuelExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              TruckFuelExpensesVatTotal = (TruckFuelExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TruckFuelExpensesNetAmountTotal = (TruckFuelExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              TruckFuelExpensesGrossTotal = (TruckFuelExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TruckFuelExpensesTotal = (TruckFuelExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataTruckFuel = downloadableCsvDataTruckFuel +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4014') {
              ElectricChargeCostExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              ElectricChargeCostExpensesVatTotal = (ElectricChargeCostExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              ElectricChargeCostExpensesNetAmountTotal = (ElectricChargeCostExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              ElectricChargeCostExpensesGrossTotal = (ElectricChargeCostExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              ElectricChargeCostExpensesTotal = (ElectricChargeCostExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataElectricChargeCost = downloadableCsvDataElectricChargeCost +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4015') {
              ElectricChargingTimeExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              ElectricChargingTimeExpensesVatTotal = (ElectricChargingTimeExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              ElectricChargingTimeExpensesNetAmountTotal = (ElectricChargingTimeExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              ElectricChargingTimeExpensesGrossTotal = (ElectricChargingTimeExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              ElectricChargingTimeExpensesTotal = (ElectricChargingTimeExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataElectricChargingTime = downloadableCsvDataElectricChargingTime +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4027') {
              ParkingExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              ParkingExpensesVatTotal = (ParkingExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              ParkingExpensesNetAmountTotal = (ParkingExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              ParkingExpensesGrossTotal = (ParkingExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              ParkingExpensesTotal = (ParkingExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataParking = downloadableCsvDataParking +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4025') {
              WaterExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              WaterExpensesVatTotal = (WaterExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              WaterExpensesNetAmountTotal = (WaterExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              WaterExpensesGrossTotal = (WaterExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              WaterExpensesTotal = (WaterExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataWater = downloadableCsvDataWater +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4026') {
              CoolantExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              CoolantExpensesVatTotal = (CoolantExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              CoolantExpensesNetAmountTotal = (CoolantExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              CoolantExpensesGrossTotal = (CoolantExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              CoolantExpensesTotal = (CoolantExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataCoolant = downloadableCsvDataCoolant +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4023') {
              AirExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              AirExpensesVatTotal = (AirExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              AirExpensesNetAmountTotal = (AirExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              AirExpensesGrossTotal = (AirExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              AirExpensesTotal = (AirExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataAir = downloadableCsvDataAir +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            else if (currentExpenseToInclude['NOMINAL_CODE'] == '4024') {
              FoodExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              FoodExpensesVatTotal = (FoodExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              FoodExpensesNetAmountTotal = (FoodExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              FoodExpensesGrossTotal = (FoodExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              FoodExpensesTotal = (FoodExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataFood = downloadableCsvDataFood +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }
            // All Expenses Extraction end
            else {
              AllOtherExpenses.push(
                <MonthlyVatReportExpenseSCCD
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              AllOtherExpensesVatTotal = (AllOtherExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              AllOtherExpensesNetAmountTotal = (AllOtherExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              AllOtherExpensesGrossTotal = (AllOtherExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              AllOtherExpensesTotal = (AllOtherExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataAllOthers = downloadableCsvDataAllOthers +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }

            downloadableCsvDataAllCodes = downloadableCsvDataFuel + 
                                      downloadableCsvDataVehicle +
                                      downloadableCsvDataTollRoad +
                                      downloadableCsvDataWaitingTime +
                                      downloadableCsvDataStorage +
                                      downloadableCsvDataBreakdown +
                                      downloadableCsvDataTravel +
                                      downloadableCsvDataCarWash +
                                      downloadableCsvDataParts +
                                      downloadableCsvDataTransports +
                                      downloadableCsvDataHotel +
                                      downloadableCsvDataTruckTravel +
                                      downloadableCsvDataTruckFuel +
                                      downloadableCsvDataElectricChargeCost +
                                      downloadableCsvDataElectricChargingTime +
                                      downloadableCsvDataParking +
                                      downloadableCsvDataWater +
                                      downloadableCsvDataCoolant +
                                      downloadableCsvDataAir+
                                      downloadableCsvDataFood+
                                      downloadableCsvDataAllOthers;
          }
        }
      }
    }
    return (
      <div>
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h2>Finance - VAT REPORT SCCD</h2>
          </div>
        </div>
        <br />
        <div className="row text-center">
          <div className="col-md-2">
            <div className="form-group month_picker">
              <select
                className="form-control form-control-lg"
                id="years"
                defaultValue={this.state.currentMonthYear}
                onChange={this.handleYearChange}
              >
                {this.buildPrevYearOptions()}
                <option key={moment().year()} value={moment().year()}>
                  {moment().year()}
                </option>
                {this.buildYearOptions()}
              </select>
            </div>
          </div>
    
          <div className="col-md-2">
            <div className="form-group month_picker">
              <select
                className="form-control form-control-lg"
                id="months"
                defaultValue={this.state.currentMonthNumber}
                disabled={this.state.isLoading}
                onChange={this.setCurrentMonth}
              >
                {this.buildMonthOptions()}
              </select>
            </div>
          </div>
        </div>
        <br />
        <div className="row text-left">
          <div className="col-md-6">
            <h2>&nbsp; Currently Showing For {currentMonthName} {currentYear} Finance - Monthly VAT Report</h2>
          </div>
          <div className="col-md-2">
            {this.state.isLoading && (
              <span className="add-loading-text">
                <i className="fa fa-spinner fa-pulse"></i>
              </span>
            )}
          </div>
          <div className="col-md-3 text-right">
            <button
              className="btn btn-primary btn-lg"
              onClick={() => this.download("Monthly VAT Report For All.csv", downloadableCsvDataAllCodes)}
            >
              <i className="fa fa-download"></i> Download for ALL Spreadsheet
            </button>
          </div>
        </div>
        <br /><br />
        {[
          {
            title: "Fuel",
            expenses: FuelExpenses,
            netTotal: FuelExpensesNetAmountTotal,
            vatTotal: FuelExpensesVatTotal,
            total: FuelExpensesTotal,
            grossTotal: FuelExpensesGrossTotal,
            csvData: downloadableCsvDataFuel,
            csvFileName: "Fuel.csv",
          },
          {
            title: "Vehicle Movements",
            expenses: VehicleExpenses,
            netTotal: VehicleExpensesNetAmountTotal,
            vatTotal: VehicleExpensesVatTotal,
            total: VehicleExpensesTotal,
            grossTotal: VehicleExpensesGrossTotal,
            csvData: downloadableCsvDataVehicle,
            csvFileName: "Vehicle.csv",
          },
          {
            title: "TOLL ROAD",
            expenses: TollRoadExpenses,
            netTotal: TollRoadExpensesNetAmountTotal,
            vatTotal: TollRoadExpensesVatTotal,
            total: TollRoadExpensesTotal,
            grossTotal: TollRoadExpensesGrossTotal,
            csvData: downloadableCsvDataTollRoad,
            csvFileName: "Tollroad.csv",
          },
          {
            title: "Waitingtime",
            expenses: WaitingTimeExpenses,
            netTotal: WaitingTimeExpensesNetAmountTotal,
            vatTotal: WaitingTimeExpensesVatTotal,
            total: WaitingTimeExpensesTotal,
            grossTotal: WaitingTimeExpensesGrossTotal,
            csvData: downloadableCsvDataWaitingTime,
            csvFileName: "Waitingtime.csv",
          },
          {
            title: "Storage",
            expenses: StorageExpenses,
            netTotal: StorageExpensesNetAmountTotal,
            vatTotal: StorageExpensesVatTotal,
            total: StorageExpensesTotal,
            grossTotal: StorageExpensesGrossTotal,
            csvData: downloadableCsvDataStorage,
            csvFileName: "Storage.csv",
          },
          {
            title: "Breakdown",
            expenses: BreakdownExpenses,
            netTotal: BreakdownExpensesNetAmountTotal,
            vatTotal: BreakdownExpensesVatTotal,
            total: BreakdownExpensesTotal,
            grossTotal: BreakdownExpensesGrossTotal,
            csvData: downloadableCsvDataBreakdown,
            csvFileName: "Breakdown.csv",
          },
          {
            title: "Travel",
            expenses: TravelExpenses,
            netTotal: TravelExpensesNetAmountTotal,
            vatTotal: TravelExpensesVatTotal,
            total: TravelExpensesTotal,
            grossTotal: TravelExpensesGrossTotal,
            csvData: downloadableCsvDataTravel,
            csvFileName: "Travel.csv",
          },
          {
            title: "Car Wash",
            expenses: CarWashExpenses,
            netTotal: CarWashExpensesNetAmountTotal,
            vatTotal: CarWashExpensesVatTotal,
            total: CarWashExpensesTotal,
            grossTotal: CarWashExpensesGrossTotal,
            csvData: downloadableCsvDataCarWash,
            csvFileName: "CarWash.csv",
          },
          {
            title: "Parts",
            expenses: PartsExpenses,
            netTotal: PartsExpensesNetAmountTotal,
            vatTotal: PartsExpensesVatTotal,
            total: PartsExpensesTotal,
            grossTotal: PartsExpensesGrossTotal,
            csvData: downloadableCsvDataParts,
            csvFileName: "Parts.csv",
          },
          {
            title: "Transport Services",
            expenses: TransportsExpenses,
            netTotal: TransportsExpensesNetAmountTotal,
            vatTotal: TransportsExpensesVatTotal,
            total: TransportsExpensesTotal,
            grossTotal: TransportsExpensesGrossTotal,
            csvData: downloadableCsvDataTransports,
            csvFileName: "TransportServices.csv",
          },
          {
            title: "Hotel",
            expenses: HotelExpenses,
            netTotal: HotelExpensesNetAmountTotal,
            vatTotal: HotelExpensesVatTotal,
            total: HotelExpensesTotal,
            grossTotal: HotelExpensesGrossTotal,
            csvData: downloadableCsvDataHotel,
            csvFileName: "Hotel.csv",
          },
          {
            title: "Truck Travel",
            expenses: TruckTravelExpenses,
            netTotal: TruckTravelExpensesNetAmountTotal,
            vatTotal: TruckTravelExpensesVatTotal,
            total: TruckTravelExpensesTotal,
            grossTotal: TruckTravelExpensesGrossTotal,
            csvData: downloadableCsvDataTruckTravel,
            csvFileName: "TruckTravel.csv",
          },
          {
            title: "Truck Fuel",
            expenses: TruckFuelExpenses,
            netTotal: TruckFuelExpensesNetAmountTotal,
            vatTotal: HotelExpensesVatTotal,
            total: TruckFuelExpensesTotal,
            grossTotal: TruckFuelExpensesGrossTotal,
            csvData: downloadableCsvDataTruckFuel,
            csvFileName: "TruckFuel.csv",
          },
          {
            title: "Electric Charge Cost",
            expenses: ElectricChargeCostExpenses,
            netTotal: ElectricChargeCostExpensesNetAmountTotal,
            vatTotal: ElectricChargeCostExpensesVatTotal,
            total: ElectricChargeCostExpensesTotal,
            grossTotal: ElectricChargeCostExpensesGrossTotal,
            csvData: downloadableCsvDataElectricChargeCost,
            csvFileName: "ElectricChargeCost.csv",
          },
          {
            title: "Electric Charging Time",
            expenses: ElectricChargingTimeExpenses,
            netTotal: ElectricChargingTimeExpensesNetAmountTotal,
            vatTotal: ElectricChargingTimeExpensesVatTotal,
            total: ElectricChargingTimeExpensesTotal,
            grossTotal: ElectricChargingTimeExpensesGrossTotal,
            csvData: downloadableCsvDataElectricChargingTime,
            csvFileName: "ElectricChargingTime.csv",
          },
          {
            title: "Parking",
            expenses: ParkingExpenses,
            netTotal: ParkingExpensesNetAmountTotal,
            vatTotal: ParkingExpensesVatTotal,
            total: ParkingExpensesTotal,
            grossTotal: ParkingExpensesGrossTotal,
            csvData: downloadableCsvDataParking,
            csvFileName: "Parking.csv",
          },
          {
            title: "Water",
            expenses: WaterExpenses,
            netTotal: WaterExpensesNetAmountTotal,
            vatTotal: WaterExpensesVatTotal,
            total: WaterExpensesTotal,
            grossTotal: WaterExpensesGrossTotal,
            csvData: downloadableCsvDataWater,
            csvFileName: "Water.csv",
          },
          {
            title: "Coolant",
            expenses: CoolantExpenses,
            netTotal: CoolantExpensesNetAmountTotal,
            vatTotal: CoolantExpensesVatTotal,
            total: CoolantExpensesTotal,
            grossTotal: CoolantExpensesGrossTotal,
            csvData: downloadableCsvDataCoolant,
            csvFileName: "Coolant.csv",
          },
          {
            title: "Air",
            expenses: AirExpenses,
            netTotal: AirExpensesNetAmountTotal,
            vatTotal: AirExpensesVatTotal,
            total: AirExpensesTotal,
            grossTotal: AirExpensesGrossTotal,
            csvData: downloadableCsvDataAir,
            csvFileName: "Air.csv",
          },
          {
            title: "Food",
            expenses: FoodExpenses,
            netTotal: FoodExpensesNetAmountTotal,
            vatTotal: FoodExpensesVatTotal,
            total: FoodExpensesTotal,
            grossTotal: FoodExpensesGrossTotal,
            csvData: downloadableCsvDataFood,
            csvFileName: "Food.csv",
          },
          {
            title: "All Other Expenses",
            expenses: AllOtherExpenses,
            netTotal: AllOtherExpensesNetAmountTotal,
            vatTotal: AllOtherExpensesVatTotal,
            total: AllOtherExpensesTotal,
            grossTotal: AllOtherExpensesGrossTotal,
            csvData: downloadableCsvDataAllOthers,
            csvFileName: "AllOtherExpenses.csv",
          },
        ].map(({ title, expenses, netTotal, vatTotal, total, grossTotal, csvData, csvFileName }) => (
          <div key={title} className="col-md-12 col-sm-12">
            <br />
            <h3 className="text-center border-bottom">{title}</h3>
            <div className="row monthly-vat-report-expense-header-container">
              <div className="col-md-2 col-sm-12 text-left">JOB ID</div>
              <div className="col-md-2 col-sm-12 text-left">NET</div>
              <div className="col-md-2 col-sm-12 text-left">VAT</div>
              <div className="col-md-1 col-sm-12 text-left">TOTAL</div>
              <div className="col-md-1 col-sm-12 text-right">TYPE</div>
              <div className="col-md-4 col-sm-12 text-right">REG &nbsp;&nbsp;&nbsp;GROSS</div>
            </div>
            {expenses}
            <div className="row">
              <div className="col-md-2 col-sm-12 text-left">
                <h1>Totals</h1>
              </div>
              <div className="col-md-2 col-sm-12 text-left">
                <h1>{netTotal.toFixed(2)}</h1>
              </div>
              <div className="col-md-2 col-sm-12 text-left">
                <h1>{vatTotal.toFixed(2)}</h1>
              </div>
              <div className="col-md-2 col-sm-12 text-left">
                <h1>{total.toFixed(2)}</h1>
              </div>
              <div className="col-md-4 col-sm-12 text-right">
                <h1>{grossTotal.toFixed(2)}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10">
                <textarea
                  className="form-control form-control-lg csv-textarea"
                  value={csvData}
                  readOnly
                />
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-primary btn-lg"
                  onClick={() => this.download(csvFileName, csvData)}
                >
                  <i className="fa fa-download"></i> Download for {title} Spreadsheet
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}
if (document.getElementById(
  'react-component-g4-logistics-portal-finance-vat-report-sccd')) {
  ReactDOM.render(
    <MonthlyVatReportSCCD
      message_if_none='Nothing to report on.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-finance-vat-report-sccd'
    )
  );
}
